(() => {
  const root = document.querySelector('.gl-living-root');
  const dialog = root?.querySelector('#newsletter-dialog');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const email = form.querySelector('#newsletter-email');
  const consent = form.querySelector('#newsletter-consent');
  const status = form.querySelector('.newsletter-submit-status');
  let opener;
  let submitting = false;
  let previousOverflow = '';
  const open = button => {
    if (dialog.open) return;
    submitting = false;
    if (status) status.textContent = '';
    opener = button || root.querySelector('[data-newsletter]');
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.scrollTop = 0;
    (form.querySelector('[data-newsletter-result]') || dialog.querySelector('#newsletter-title')).focus({preventScroll: true});
  };
  root.querySelectorAll('[data-newsletter]').forEach(button => button.addEventListener('click', () => open(button)));
  dialog.querySelector('.newsletter-close').addEventListener('click', () => dialog.close());
  const error = (input, message) => {
    if (!input) return;
    const output = dialog.querySelector('#' + input.id + '-error');
    output.textContent = message;
    output.hidden = !message;
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };
  if (email && consent) {
    form.noValidate = false;
    email.addEventListener('input', () => error(email, ''));
    consent.addEventListener('change', () => error(consent, ''));
    const validate = () => {
      const emailMessage = !email.value.trim() ? email.dataset.requiredMessage
        : !email.validity.valid ? email.dataset.invalidMessage : '';
      const consentMessage = !consent.checked ? consent.dataset.requiredMessage : '';
      error(email, emailMessage);
      error(consent, consentMessage);
      if (emailMessage || consentMessage) {
        status.textContent = '';
        (emailMessage ? email : consent).focus();
        return false;
      }
      return true;
    };
    form.addEventListener('invalid', event => {
      event.preventDefault();
      validate();
    }, true);
    form.addEventListener('click', event => {
      if (!event.target.closest('button[type="submit"]') || validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    form.addEventListener('submit', event => {
      if (!validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      status.textContent = status.dataset.submittingMessage;
      // Shopify's CAPTCHA is outside this dialog. Release the modal top layer
      // without resetting the form so the native challenge remains accessible.
      submitting = true;
      dialog.close();
    }, true);
  }
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]),input:not([disabled]):not([type="hidden"]),a[href]')].filter(element => element.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (!submitting) {
      form.reset();
      error(email, ''); error(consent, '');
      if (status) status.textContent = '';
      opener?.focus({preventScroll: true});
    }
  });
  const result = form.querySelector('[data-newsletter-result]');
  if (result) {
    open();
    // Restore focus after native post/fragment navigation finishes loading.
    const focusResult = () => requestAnimationFrame(() => {
      if (dialog.open && (document.activeElement === document.body || document.activeElement === form)) result.focus({preventScroll: true});
    });
    if (document.readyState === 'complete') focusResult();
    else window.addEventListener('load', focusResult, {once: true});
  }
})();
